<template>
  <div>
    <shop-header :store-id="storeid" />
    <section class="bg-white position-sticky" style="top:0;z-index:6">
      <div class="container-fluid">
        <div class="container"></div>
      </div>
    </section>
    <div class="container">
      <div class="row main-container" v-if="storeMenu">
        <main class="col-sm-7 col-xl-8">
          <GiftProductList :menu="JSON.parse(JSON.stringify(storeMenu))" />
        </main>
        <aside class="col-sm-5 col-xl-4" id="shopping-cart">
          <ShoppingCart />
        </aside>
      </div>
    </div>
    <shopfooter />
  </div>
</template>
<script>
import GiftProductList from "./../giftproducts/GiftProductList.vue";
import ShoppingCart from "../../giftcard/giftshoppingcart/GiftShoppingCart";
import ShopHeader from "../../../components/shop/partials/shopheader";
import shopfooter from "../../../components/shared/shopfooter";
import { mapMutations, mapActions, mapGetters } from "vuex";
export default {
  components: {
    GiftProductList,
    ShoppingCart,
    ShopHeader,
    shopfooter
  },
  props: {
    storeid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["storeMenu"])
  },
  mounted() {
    const self = this;
    this.setStore(this.storeid);
    this.initStore({
      storeId: this.storeid,
      callback: () => {
          self.setStoreLoaded();
      },
    });
    this.getStoreMenu(this.storeid);
  },
  methods: {
    ...mapMutations(["setStore", "setStoreLoaded"]),
    ...mapActions([
      "initStore",
      "getStoreMenu",
      "insertErrorlog",
      "redirectToErrorPage"
    ])
  }
};
</script>
